module.exports = __webpack_public_path__ + "static/media/twitter.c1b4fb0f.svg";